module.exports = __webpack_public_path__ + "static/07-0c84529b2c60f17f42b094e6c72139c1.jpg";